<template>
  <div id="app">
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <i-home-foot v-if="isshow"></i-home-foot>
  </div>
</template>

<script>
import iHomeFoot from './components/Home/HomeFoot'
export default {
  data () {
    return {
      isshow: false,
    }
  },
  name: 'App',
  components: {
    iHomeFoot
  },
  mounted () {
    setTimeout(() => {
      this.isshow = true;
    }, 500)
  },
}
</script>

<style type="text/scss" lang="scss">
#app {
  font-family: "Microsoft YaHei";
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
  min-height: 100%;
}
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
font,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  /*font-size: 100%;*/
  vertical-align: baseline;
  background: transparent;
}
body,
html {
  height: 100%;
  line-height: 1;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

/* remember to define focus styles! */
:focus {
  outline: 0;
}

/* remember to highlight inserts somehow! */
ins {
  text-decoration: none;
}
del {
  text-decoration: line-through;
}

/* tables still need 'cellspacing="0"' in the markup */
table {
  border-collapse: collapse;
  border-spacing: 0;
}
.input.is-danger {
  border: 1px solid red;
  border-color: red;
}
.help.is-danger {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/App.vue